import { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import Button from '@mui/material/Button'

import { convertFromCents, printPrice,  } from '@/helpers'
import type { YearlyFeePayerSingle } from '@/types'
import AssignDiscountToPayerCustomForm from '@/components/forms/assign-discount-to-payer'
import FeePayerDiscountActions from './actions'
import HouseholdMemberCustomDiscountForm from '@/components/forms/household-member-custom-discount'

function YearlyFeePayerDiscounts({
    yearlyFeePayer,
}: {
    yearlyFeePayer: YearlyFeePayerSingle,
}) {

    const [createForMember, setCreateForMember] = useState<boolean>(false)
    const [createForHousehold, setCreateForHousehold] = useState<boolean>(false)
    const [add, setAdd] = useState<boolean>(false)

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            overflowX: 'auto',
            mt: 3,
        }}>
            <Box px={2.5}>
                <Typography variant="h3" component="h2">
                    Slevy
                </Typography>
            </Box>
            {yearlyFeePayer.discounts?.length === 0 ?
                <Box px={2.5}>
                    Poplatník nemá nastavené žádné slevy
                </Box>
            :
                <Table
                    size="small"
                    aria-label="Seznam slev"
                    sx={{
                        mt: 1,
                        minWidth: 600,
                    }}
                >
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ paddingLeft: 3 }}>ID</TableCell>
                            <TableCell>Název</TableCell>
                            <TableCell>Výše (Kč)</TableCell>
                            <TableCell align="right"/>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {yearlyFeePayer.discounts.map(row => (
                            <TableRow
                                key={row.id}
                                sx={{
                                    '&:last-child td, &:last-child th': { border: 0 },
                                }}
                            >
                                <TableCell component="th" scope="row" sx={{ paddingLeft: 3 }}>
                                    {row.id}
                                </TableCell>
                                <TableCell>
                                    {row.name}
                                </TableCell>
                                <TableCell>
                                    {printPrice(convertFromCents(row.amount_cents))}
                                </TableCell>
                                <TableCell align="right">
                                    <FeePayerDiscountActions
                                        discountId={row.id}
                                        feePayerId={yearlyFeePayer.id}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            }
            <Box px={2.5} py={1.5} sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 2,
            }}>
                {add ?
                    <Box maxWidth="sm">
                        <AssignDiscountToPayerCustomForm
                            feePayerId={yearlyFeePayer.id}
                            closeCallback={() => setAdd(false)}
                        />
                    </Box>
                    :
                    <Box>
                        <Button
                            variant="contained"
                            color="terciary"
                            startIcon={<AddRoundedIcon />}
                            onClick={() => setAdd(true)}
                        >
                            Přidat poplatníkovi slevu
                        </Button>
                    </Box>
                }
                {createForMember ?
                    <Box maxWidth="sm">
                        <HouseholdMemberCustomDiscountForm
                            feePayerId={yearlyFeePayer.id}
                            closeCallback={() => setCreateForMember(false)}
                            type='household_member'
                        />
                    </Box>
                    :
                    <Box>
                        <Button
                            variant="outlined"
                            color="terciary"
                            startIcon={<AddRoundedIcon />}
                            onClick={() => setCreateForMember(true)}
                        >
                            Vytvořit poplatníkovi slevu na míru
                        </Button>
                    </Box>
                }
                {createForHousehold ?
                    <Box maxWidth="sm">
                        <HouseholdMemberCustomDiscountForm
                            feePayerId={yearlyFeePayer.id}
                            closeCallback={() => setCreateForHousehold(false)}
                            type='household'
                        />
                    </Box>
                    :
                    <Box>
                        <Button
                            variant="outlined"
                            color="terciary"
                            startIcon={<AddRoundedIcon />}
                            onClick={() => setCreateForHousehold(true)}
                        >
                            Vytvořit svozovému místu slevu na míru
                        </Button>
                    </Box>
                }
            </Box>
        </Box>
    )
}

export default YearlyFeePayerDiscounts
